/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * 十八线_接口文档
 * 十八线——小众旅游
 * OpenAPI spec version: 版本号:0.0.1
 */
import type {
  AjaxResult,
  RewardRefundApplyDTO,
  RewardRefundPollOneParams,
  RewardRefundPreviewParams
} from '../../../types/api';

import { orvalMutator } from '../../../utils/orval-mutator';



  export const get = () => {
/**
 * @summary 发起打赏退款（启动微信退款任务）
 */
const rewardRefundApply = (
    rewardRefundApplyDTO: RewardRefundApplyDTO,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/refund`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: rewardRefundApplyDTO
    },
      );
    }
  /**
 * @summary 手工触发退款终态轮询
 */
const rewardRefundPoll = (

 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/refund/poll`, method: 'POST'
    },
      );
    }
  /**
 * @summary 手工轮询单笔退款终态
 */
const rewardRefundPollOne = (
    params: RewardRefundPollOneParams,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/refund/poll/one`, method: 'POST',
        params
    },
      );
    }
  /**
 * @summary 退款前预览（实时向微信查询可退余额）
 */
const rewardRefundPreview = (
    params: RewardRefundPreviewParams,
 ) => {
      return orvalMutator<AjaxResult>(
      {url: `/travel18/reward/refund/preview`, method: 'GET',
        params
    },
      );
    }
  return {rewardRefundApply,rewardRefundPoll,rewardRefundPollOne,rewardRefundPreview}};
export type RewardRefundApplyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardRefundApply']>>>
export type RewardRefundPollResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardRefundPoll']>>>
export type RewardRefundPollOneResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardRefundPollOne']>>>
export type RewardRefundPreviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof get>['rewardRefundPreview']>>>
